import { PodMember } from '@/types/pods';

export const validatePodMember = (member: PodMember): string | null => {
	if (!member.email && !member.socialUsername && !member.uploadPostProfileKey) {
		return 'All member fields are required';
	}
	if (!member.email) {
		return 'Email is required';
	}
	if (!member.socialUsername) {
		return 'Social Username is required';
	}
	if (!member.uploadPostProfileKey) {
		return 'Upload Post profile key is required';
	}
	return null;
};
